import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { KENDO_RIPPLE } from "@progress/kendo-angular-ripple";
import { KENDO_DIALOGS } from "@progress/kendo-angular-dialog";
import { ButtonComponent } from "@progress/kendo-angular-buttons";
import { GlobalErrorService } from "src/app/services/global-error.service";
import { Icons } from "src/app/icons";
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-root',
    imports: [
        TranslateModule,
        RouterOutlet,
        KENDO_RIPPLE,
        KENDO_DIALOGS,
        ButtonComponent,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    errorService = inject(GlobalErrorService);
    private translateService = inject(TranslateService);
    protected readonly icons = Icons;
    protected readonly copied = signal(false);

    /* Copies the diagnostic report so the user can paste it into the report email. */
    async copyError() {
        const text = this.errorService.report();
        if (!text) return;
        try {
            await navigator.clipboard.writeText(text);
        } catch {
            this.fallbackCopy(text);
        }
        this.copied.set(true);
        setTimeout(() => this.copied.set(false), 2000);
    }

    /* Opens the email client with greeting + error logs in the body. */
    sendErrorReport() {
        const greeting = this.translateService.instant('errorGreeting');
        const report = this.errorService.report();
        const body = greeting + (report || '');
        const subject = encodeURIComponent('Report Booking Error');
        const encodedBody = encodeURIComponent(body);
        const mailtoUrl = `mailto:${environment.supportMail}?subject=${subject}&body=${encodedBody}`;
        window.location.href = mailtoUrl;
    }

    private fallbackCopy(text: string) {
        try {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            // Fallback for cross-origin iframes where Clipboard API is blocked.
            document.execCommand('copy');
            document.body.removeChild(textarea);
        } catch { /* ignore */ }
    }
}
